import { win } from '../../utils/win';

export const isInAppBrowser = (): boolean => {
  const rules = [
    `WebView`,
    `(iPhone|iPod|iPad)(?!.*Safari\/)`,
    `Android.*(wv|\.0\.0\.0)`,
  ];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');

  return regex.test(win.navigator?.userAgent);
};
